module.exports = function getResource(label, vars = []) {
    let resources = {
        resetPassword: 'Reset Password',
        resetLinkExpired: 'Your reset password link has expired or is invalid. Please try again.',
        pleaseCreateNewPassword: 'Please create a new password (6-12 characters long) to access your account.',
        newPassword: 'New password',
        confirmPassword: 'Confirm password',
        continue: 'Continue',
        stillHavingTrouble: 'Still having trouble?',
        unableToResetPassword: 'If you’re unable to reset your password, please call Customer Service at',
        TTY: 'TTY',
        forAssistance: 'for assistance.',
        confirmError: 'The passwords you entered do not match. Please fix to continue',
        resetSuccessful: 'Reset successful',
        passwordHasBeenReset: 'Your password has been reset and you will be receiving an email confirmation soon.',
        viewProfile: 'VIEW PROFILE'
    };
    return resources[label];
};
